// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL: 'https://int0-auth-internal.actabl.com',
  appSwitcherUrl:
    'https://int0-login.actabl.com/app-switcher/latest/unified-platform-app-switcher-bundle.js',
  storeDevtoolsModuleMaxAge: 25,
  availableLangs: ['en', 'pt-BR'],
  productUrls: {
    AL: 'https://int0-auth.aliceapp.com/login-staff',
    HE: 'https://my-dev.hoteleffectiveness.com/signin',
  },
};
